<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post12-iran-attacked-countries-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post12-iran-attacked-countries-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.7320107633164;"
    data-aspect-ratio="0.732"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post12-iran-attacked-countries-xs-img"
      class="g-post12-iran-attacked-countries-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post12-iran-attacked-countries-xs.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai0-1"
      class="g-Legend-xs-sm g-aiAbs"
      style="top:1.1091%;left:5.2853%;width:46.6667%;"
    >
      <p class="g-pstyle0">Countries attacked by Iran</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:15.6288%;margin-top:-6.5px;left:57.3414%;margin-left:-24.5px;width:49px;"
    >
      <p class="g-pstyle1">Azer.</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:20.9525%;margin-top:-18.5px;left:90.3205%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle2">Turk.</p>
      <p>&nbsp;</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:19.8434%;margin-top:-6.5px;left:17.2976%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle2">TURKEY</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:31.1563%;margin-top:-6.5px;left:6.4574%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle2">CYPRUS</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:31.5999%;margin-top:-6.5px;left:23.6546%;margin-left:-25.5px;width:51px;"
    >
      <p class="g-pstyle2">Syria</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:40.251%;margin-top:-6.5px;left:40.4372%;margin-left:-23px;width:46px;"
    >
      <p class="g-pstyle2">Iraq</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:40.4728%;margin-top:-6.5px;left:5.8253%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle2">Israel</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:40.7038%;margin-top:-6.5px;left:79.558%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:47.3492%;margin-top:-6.5px;left:12.6033%;width:60px;"
    >
      <p class="g-pstyle4">Jordan</p>
    </div>
    <div
      id="g-ai0-11"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:53.3384%;margin-top:-6.5px;right:32.9004%;width:60px;"
    >
      <p class="g-pstyle5">KUWAIT</p>
    </div>
    <div
      id="g-ai0-12"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:59.3276%;margin-top:-6.5px;right:34.8628%;width:67px;"
    >
      <p class="g-pstyle5">Bahrain</p>
    </div>
    <div
      id="g-ai0-13"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:62.8767%;margin-top:-12.5px;left:43.0423%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle2">Saudi</p>
      <p class="g-pstyle2">Arabia</p>
    </div>
    <div
      id="g-ai0-14"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:61.7676%;margin-top:-6.5px;left:71.5841%;width:55px;"
    >
      <p class="g-pstyle6">Qatar</p>
    </div>
    <div
      id="g-ai0-15"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:68.2005%;margin-top:-6.5px;left:79.2207%;margin-left:-21px;width:42px;"
    >
      <p class="g-pstyle2">UAE</p>
    </div>
    <div
      id="g-ai0-16"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:72.6369%;margin-top:-6.5px;left:90.9591%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle2">Oman</p>
    </div>
    <div
      id="g-ai0-17"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:89.4953%;margin-top:-6.5px;left:55.7376%;margin-left:-28.5px;width:57px;"
    >
      <p class="g-pstyle2">Yemen</p>
    </div>
    <div
      id="g-ai0-18"
      class="g-military-bases_copy_3 g-aiAbs"
      style="top:89.394%;left:74.5163%;width:31.5152%;"
    >
      <p class="g-pstyle7">US military bases</p>
      <p class="g-pstyle7">in the region</p>
    </div>
    <div
      id="g-ai0-19"
      class="g-scale g-aiAbs g-aiPointText"
      style="top:97.8136%;margin-top:-5px;left:90.899%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle8">500km</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post12-iran-attacked-countries-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.85736814058131;"
    data-aspect-ratio="0.857"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post12-iran-attacked-countries-sm-img"
      class="g-post12-iran-attacked-countries-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post12-iran-attacked-countries-sm.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai1-1"
      class="g-Legend-xs-sm g-aiAbs"
      style="top:0.6724%;left:4.4985%;width:37.2549%;"
    >
      <p class="g-pstyle0">Countries attacked by Iran</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:14.8775%;margin-top:-6.5px;left:56.2487%;margin-left:-26px;width:52px;"
    >
      <p class="g-pstyle1">Azer.</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:17.9035%;margin-top:-6.5px;left:88.0576%;margin-left:-53.5px;width:107px;"
    >
      <p class="g-pstyle2">Turkmenistan</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:18.9122%;margin-top:-6.5px;left:19.7932%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle2">TURKEY</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:31.1843%;margin-top:-6.5px;left:6.1063%;margin-left:-32.5px;width:65px;"
    >
      <p class="g-pstyle2">CYPRUS</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:31.5206%;margin-top:-6.5px;left:29.096%;margin-left:-27px;width:54px;"
    >
      <p class="g-pstyle2">Syria</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:39.9261%;margin-top:-6.5px;left:42.2742%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle2">Iraq</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:40.4444%;margin-top:-6.6px;left:77.4144%;margin-left:-33.5px;width:67px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:40.7667%;margin-top:-6.5px;left:12.7466%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle2">Israel</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:46.9868%;margin-top:-6.5px;left:18.4468%;width:63px;"
    >
      <p class="g-pstyle4">Jordan</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:52.8707%;margin-top:-6.5px;right:34.1027%;width:64px;"
    >
      <p class="g-pstyle5">KUWAIT</p>
    </div>
    <div
      id="g-ai1-12"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:59.2589%;margin-top:-6.5px;right:36.4455%;width:71px;"
    >
      <p class="g-pstyle5">Bahrain</p>
    </div>
    <div
      id="g-ai1-13"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:62.4385%;margin-top:-12.4px;left:44.5981%;margin-left:-31.5px;width:63px;"
    >
      <p class="g-pstyle2">Saudi</p>
      <p class="g-pstyle2">Arabia</p>
    </div>
    <div
      id="g-ai1-14"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:61.6125%;margin-top:-6.5px;left:69.2929%;width:58px;"
    >
      <p class="g-pstyle6">Qatar</p>
    </div>
    <div
      id="g-ai1-15"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:67.8326%;margin-top:-6.5px;left:76.7524%;margin-left:-22px;width:44px;"
    >
      <p class="g-pstyle2">UAE</p>
    </div>
    <div
      id="g-ai1-16"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:73.2122%;margin-top:-6.5px;left:85.0278%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">Oman</p>
    </div>
    <div
      id="g-ai1-17"
      class="g-military-bases_copy_2 g-aiAbs g-aiPointText"
      style="top:90.5277%;margin-top:-12.5px;left:76.1935%;width:113px;"
    >
      <p class="g-pstyle7">US military bases</p>
      <p class="g-pstyle7">in the region</p>
    </div>
    <div
      id="g-ai1-18"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:89.519%;margin-top:-6.5px;left:55.437%;margin-left:-30px;width:60px;"
    >
      <p class="g-pstyle2">Yemen</p>
    </div>
    <div
      id="g-ai1-19"
      class="g-basemap_copy_2 g-aiAbs g-aiPointText"
      style="top:97.084%;margin-top:-6.5px;left:90.9088%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle8">500km</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post12-iran-attacked-countries-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 0.86271890724181;"
    data-aspect-ratio="0.863"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post12-iran-attacked-countries-md-img"
      class="g-post12-iran-attacked-countries-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post12-iran-attacked-countries-md.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai2-1"
      class="g-Legend_copy g-aiAbs"
      style="top:1.6993%;left:4.4964%;width:27.7273%;"
    >
      <p class="g-pstyle0">Countries attacked by Iran</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:11.7096%;margin-top:-8.6px;left:53.1867%;width:59px;"
    >
      <p class="g-pstyle1">Azer.</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:14.9775%;margin-top:-8.6px;left:87.7865%;margin-left:-60.5px;width:121px;"
    >
      <p class="g-pstyle2">Turkmenistan</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:16.0232%;margin-top:-8.6px;left:17.6798%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle2">TURKEY</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:28.3104%;margin-top:-8.6px;left:4.5765%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle2">CYPRUS</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:29.0947%;margin-top:-8.6px;left:27.3025%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle2">Syria</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:37.9833%;margin-top:-8.6px;left:41.0406%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle2">Iraq</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:38.6477%;margin-top:-8.7px;left:77.3451%;margin-left:-36.5px;width:73px;"
    >
      <p class="g-pstyle3">Iran</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:38.8983%;margin-top:-8.6px;left:11.1853%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle2">Israel</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:45.8262%;margin-top:-8.6px;left:15.9684%;width:73px;"
    >
      <p class="g-pstyle1">Jordan</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:50.5319%;margin-top:-8.6px;right:34.955%;width:71px;"
    >
      <p class="g-pstyle4">KUWAIT</p>
    </div>
    <div
      id="g-ai2-12"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:58.1134%;margin-top:-8.6px;right:36.8361%;width:80px;"
    >
      <p class="g-pstyle4">Bahrain</p>
    </div>
    <div
      id="g-ai2-13"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:60.3356%;margin-top:-8.6px;left:69.0857%;width:64px;"
    >
      <p class="g-pstyle1">Qatar</p>
    </div>
    <div
      id="g-ai2-14"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:61.5024%;margin-top:-16.5px;left:43.323%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle2">Saudi</p>
      <p class="g-pstyle2">Arabia</p>
    </div>
    <div
      id="g-ai2-15"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:67.002%;margin-top:-8.6px;left:76.7224%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle2">UAE</p>
    </div>
    <div
      id="g-ai2-16"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:72.6228%;margin-top:-8.6px;left:85.214%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle2">Oman</p>
    </div>
    <div
      id="g-ai2-17"
      class="g-military-bases_copy g-aiAbs g-aiPointText"
      style="top:90.5307%;margin-top:-14.6px;left:76.1176%;width:128px;"
    >
      <p class="g-pstyle5">US military bases</p>
      <p class="g-pstyle5">in the region</p>
    </div>
    <div
      id="g-ai2-18"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:89.7464%;margin-top:-8.6px;left:54.5903%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle2">Yemen</p>
    </div>
    <div
      id="g-ai2-19"
      class="g-basemap_copy g-aiAbs g-aiPointText"
      style="top:97.7109%;margin-top:-8.5px;left:91.2959%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle6">500km</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post12-iran-attacked-countries-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 1.14267010738019;"
    data-aspect-ratio="1.143"
    data-min-width="930"
  >
    <div
      id="g-post12-iran-attacked-countries-lg-img"
      class="g-post12-iran-attacked-countries-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post12-iran-attacked-countries-lg.jpg);"
      loading="lazy"
    ></div>
    <div
      id="g-ai3-1"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:9.1022%;margin-top:-9.1px;left:48.7791%;margin-left:-50px;width:100px;"
    >
      <p class="g-pstyle0">Azerbaijan</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:13.5254%;margin-top:-9.1px;left:19.0214%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle0">TURKEY</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:14.1398%;margin-top:-9.1px;left:77.8199%;margin-left:-60.5px;width:121px;"
    >
      <p class="g-pstyle0">Turkmenistan</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:26.5494%;margin-top:-9.1px;left:8.7332%;margin-left:-36px;width:72px;"
    >
      <p class="g-pstyle0">CYPRUS</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:26.918%;margin-top:-9.1px;left:26.4938%;margin-left:-29.5px;width:59px;"
    >
      <p class="g-pstyle0">Syria</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:36.0102%;margin-top:-9.1px;left:37.1614%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle0">Iraq</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:36.6398%;margin-top:-9.2px;left:65.3411%;margin-left:-38px;width:76px;"
    >
      <p class="g-pstyle1">Iran</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:36.9932%;margin-top:-9.1px;left:13.9816%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle0">Israel</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:44.1195%;margin-top:-9.1px;left:17.6943%;width:73px;"
    >
      <p class="g-pstyle2">Jordan</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:48.9113%;margin-top:-9.1px;right:44.2003%;width:71px;"
    >
      <p class="g-pstyle3">KUWAIT</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:56.7749%;margin-top:-9.1px;right:45.6634%;width:80px;"
    >
      <p class="g-pstyle3">Bahrain</p>
    </div>
    <div
      id="g-ai3-12"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:60.1749%;margin-top:-17.8px;left:38.9362%;margin-left:-34.5px;width:69px;"
    >
      <p class="g-pstyle0">Saudi</p>
      <p class="g-pstyle0">Arabia</p>
    </div>
    <div
      id="g-ai3-13"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:59.3551%;margin-top:-9.1px;right:36.8803%;width:64px;"
    >
      <p class="g-pstyle3">Qatar</p>
    </div>
    <div
      id="g-ai3-14"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:65.8671%;margin-top:-9.1px;left:64.5434%;margin-left:-24px;width:48px;"
    >
      <p class="g-pstyle0">UAE</p>
    </div>
    <div
      id="g-ai3-15"
      class="g-Legend g-aiAbs"
      style="top:65.1199%;left:83.0106%;width:13.5484%;"
    >
      <p class="g-pstyle4">Countries attacked by Iran</p>
    </div>
    <div
      id="g-ai3-16"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:71.6419%;margin-top:-9.1px;left:71.4626%;margin-left:-30.5px;width:61px;"
    >
      <p class="g-pstyle0">Oman</p>
    </div>
    <div
      id="g-ai3-17"
      class="g-military-bases g-aiAbs g-aiPointText"
      style="top:90.0106%;margin-top:-14.6px;left:64.3979%;width:128px;"
    >
      <p class="g-pstyle5">US military bases</p>
      <p class="g-pstyle5">in the region</p>
    </div>
    <div
      id="g-ai3-18"
      class="g-country-labels g-aiAbs g-aiPointText"
      style="top:89.2119%;margin-top:-9.1px;left:47.6833%;margin-left:-33px;width:66px;"
    >
      <p class="g-pstyle0">Yemen</p>
    </div>
    <div
      id="g-ai3-19"
      class="g-basemap g-aiAbs g-aiPointText"
      style="top:96.6008%;margin-top:-9.2px;left:92.59%;margin-left:-34px;width:68px;"
    >
      <p class="g-pstyle6">500km</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-05 12:24 -->

<!-- Generated by ai2svelte v0.123.1 - 2026-03-05 12:24 -->
<!-- ai file: post12-iran-attacked-countries.ai -->
<style lang="scss">
  #g-post12-iran-attacked-countries-box {
    container-type: inline-size;
    container-name: g-post12-iran-attacked-countries-box;
  }
  #g-post12-iran-attacked-countries-box,
  #g-post12-iran-attacked-countries-box .g-artboard {
    margin: 0 auto;
  }
  #g-post12-iran-attacked-countries-box p {
    margin: 0;
  }
  #g-post12-iran-attacked-countries-box .g-aiAbs {
    position: absolute;
  }
  #g-post12-iran-attacked-countries-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post12-iran-attacked-countries-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post12-iran-attacked-countries-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post12-iran-attacked-countries-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post12-iran-attacked-countries-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post12-iran-attacked-countries-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post12-iran-attacked-countries-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post12-iran-attacked-countries-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-post12-iran-attacked-countries-lg {
        display: block !important;
      }
    }
  }
  #g-post12-iran-attacked-countries-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post12-iran-attacked-countries-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 12px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 11px;
    text-align: left;
    text-transform: none;
    color: rgb(153, 153, 153);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post12-iran-attacked-countries-xs .g-pstyle0 {
    font-weight: 700;
    font-size: 13px;
    color: rgb(102, 102, 102);
  }
  #g-post12-iran-attacked-countries-xs .g-pstyle1 {
    font-weight: 400;
    height: 12px;
    letter-spacing: -0.05em;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-xs .g-pstyle2 {
    font-weight: 400;
    height: 12px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-xs .g-pstyle3 {
    font-weight: 900;
    height: 12px;
    letter-spacing: 0.27em;
    font-size: 12px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-post12-iran-attacked-countries-xs .g-pstyle4 {
    font-weight: 400;
    height: 12px;
    letter-spacing: -0.05em;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-xs .g-pstyle5 {
    font-weight: 400;
    height: 12px;
    text-align: right;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-xs .g-pstyle6 {
    font-weight: 400;
    height: 12px;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-xs .g-pstyle7 {
    font-weight: 500;
  }
  #g-post12-iran-attacked-countries-xs .g-pstyle8 {
    font-weight: 400;
    line-height: 9px;
    height: 9px;
    text-align: center;
  }
  #g-post12-iran-attacked-countries-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post12-iran-attacked-countries-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 12px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 12px;
    text-align: left;
    text-transform: none;
    color: rgb(153, 153, 153);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post12-iran-attacked-countries-sm .g-pstyle0 {
    font-weight: 700;
    line-height: 13px;
    font-size: 13px;
    color: rgb(102, 102, 102);
  }
  #g-post12-iran-attacked-countries-sm .g-pstyle1 {
    font-weight: 400;
    height: 12px;
    letter-spacing: -0.05em;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-sm .g-pstyle2 {
    font-weight: 400;
    height: 12px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-sm .g-pstyle3 {
    font-weight: 900;
    height: 12px;
    letter-spacing: 0.27em;
    font-size: 14px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-post12-iran-attacked-countries-sm .g-pstyle4 {
    font-weight: 400;
    height: 12px;
    letter-spacing: -0.05em;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-sm .g-pstyle5 {
    font-weight: 400;
    height: 12px;
    text-align: right;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-sm .g-pstyle6 {
    font-weight: 400;
    height: 12px;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-sm .g-pstyle7 {
    font-weight: 700;
    height: 12px;
  }
  #g-post12-iran-attacked-countries-sm .g-pstyle8 {
    font-weight: 400;
    height: 12px;
    text-align: center;
  }
  #g-post12-iran-attacked-countries-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post12-iran-attacked-countries-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    text-transform: none;
    color: rgb(153, 153, 153);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post12-iran-attacked-countries-md .g-pstyle0 {
    font-weight: 700;
    line-height: 15px;
    font-size: 15px;
    color: rgb(102, 102, 102);
  }
  #g-post12-iran-attacked-countries-md .g-pstyle1 {
    font-weight: 400;
    height: 16px;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-md .g-pstyle2 {
    font-weight: 400;
    height: 16px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-md .g-pstyle3 {
    font-weight: 900;
    height: 16px;
    letter-spacing: 0.27em;
    font-size: 16px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-post12-iran-attacked-countries-md .g-pstyle4 {
    font-weight: 400;
    height: 16px;
    text-align: right;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-md .g-pstyle5 {
    font-weight: 700;
    line-height: 14px;
    height: 14px;
  }
  #g-post12-iran-attacked-countries-md .g-pstyle6 {
    font-weight: 400;
    height: 16px;
    text-align: center;
  }
  #g-post12-iran-attacked-countries-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post12-iran-attacked-countries-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 17px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    text-transform: none;
    color: rgb(153, 153, 153);
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post12-iran-attacked-countries-lg .g-pstyle0 {
    font-weight: 400;
    height: 17px;
    text-align: center;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-lg .g-pstyle1 {
    font-weight: 900;
    height: 17px;
    letter-spacing: 0.27em;
    font-size: 17px;
    text-align: center;
    text-transform: uppercase;
    color: rgb(102, 102, 102);
  }
  #g-post12-iran-attacked-countries-lg .g-pstyle2 {
    font-weight: 400;
    height: 17px;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-lg .g-pstyle3 {
    font-weight: 400;
    height: 17px;
    text-align: right;
    text-transform: uppercase;
  }
  #g-post12-iran-attacked-countries-lg .g-pstyle4 {
    font-weight: 700;
    line-height: 16px;
    font-size: 16px;
    color: rgb(102, 102, 102);
  }
  #g-post12-iran-attacked-countries-lg .g-pstyle5 {
    font-weight: 700;
    line-height: 14px;
    height: 14px;
  }
  #g-post12-iran-attacked-countries-lg .g-pstyle6 {
    font-weight: 400;
    height: 17px;
    font-size: 15px;
    text-align: center;
  }

  /* Custom CSS */
  @mixin shadow-asiago($clr) {
    text-shadow:
      rgba($clr, 0.3) 0.5px 0px 0px,
      rgba($clr, 0.3) 0.540302px 0.841471px 0px,
      rgba($clr, 0.3) -0.416147px 0.909297px 0px,
      rgba($clr, 0.3) -0.989992px 0.14112px 0px,
      rgba($clr, 0.3) -0.653644px -0.756802px 0px,
      rgba($clr, 0.3) 0.283662px -0.958924px 0px,
      rgba($clr, 0.3) 0.96017px -0.279415px 0px;
  }
  .g-country-labels {
    @include shadow-asiago(#ffffff);
  }
</style>
